"use client";
import "@ant-design/v5-patch-for-react-19";
import { ConfigProvider, App } from "antd";
import { customTheme } from "../../styles/customTheme";

export default function AntdProvider({ children }: { children: React.ReactNode }) {
  return (
    <ConfigProvider theme={customTheme}>
      <App>{children}</App>
    </ConfigProvider>
  );
}
